import styled from 'styled-components';

export const Paragraph = styled.p`
  color: #ec3237;
  font-size: 0.9rem;
`;
